import React, {useState} from 'react'

import BkIcon from "./icons/domino/bk_icon";
import {send_edit_cmd} from "../../etc/cmd";

import c from "../../etc/Const"


//const p0 = c.p0;
const p1 = c.p1;
//const p2 = c.p2;
//const p4 = c.p4;
//const p8 = c.p8;
//const p16 = c.p16;
//const p32 = c.p32;

const Bk = ({root, item, idClick, width, lcs}) => {

    //const [hover, setHover] = useState(false);

    const [anchorPoint, setAnchorPoint] = useState({x: 0, y: 0});
    const [show, setShow] = useState(false);

    /*
    var lcitem = lcs && lcs.find((itm) => {
        return itm.id === item.lcid && item.lcid !== '-';
    });

    var stbitem = lcs && lcs.find((itm) => {
        return itm.id === item.streckenblock;
    });*/

    function handleMenuClick(e) {
        setShow(false);
    }

    function handleArrowClick(e) {
        e.preventDefault();

        console.log("BK ARROW KLICK " + item.lcid);

        let cc = {
            name: "lc",
            id: item.lcid,
            mode: 'auto',
            informall: true,
        };
        console.log(cc);
        //sendToServer(cc);

    }

    function handleClick(e) {
        e.preventDefault();

        console.log("BK KLICK");

    }

    function rightClick(e) {
        e.preventDefault();
        setAnchorPoint({x: e.pageX, y: e.pageY});
        setShow(true);

        console.log("BK RIGHT KLICK " + item.id);
    }

    function handleDragStart(e) {
        e.dataTransfer.setData("id", item.id);
        e.dataTransfer.setData("name", item.name);
        e.dataTransfer.setData("lcid", item.lcid);
        console.log("drag: " + item.id);
    }

    function handleDrag(e) {
        e.preventDefault();
    }

    function handleDrop(e) {
        e.preventDefault();

        var name = e.dataTransfer.getData("name");
        var id = e.dataTransfer.getData("id");
        var lcid = e.dataTransfer.getData("lcid");
        console.log("drop: [" + name + "] - [" + id + "] in: [" + item.id + "]");

        if (name === "lc") {
            if (id !== "") {
                let cc = {
                    id: item.id,
                    name: item.name,
                    lcid: id,
                    cmd: "setlc"
                };
                //console.log(cc);
                send_edit_cmd(cc)
            } else {
                let cc = {
                    id: item.id,
                    name: item.name,
                    lcid: "",
                    cmd: "reset",
                    lock: "",
                    lockid: "",
                    lockdir: ""
                };
                //console.log(cc);
                send_edit_cmd(cc)
            }
        }
        /*
        if( name === "bk") {
            sendToServer({
                id: lcid,
                name: "lc",
                cmd: "goto",
                target: item.id
            })
        }
         */
    }

    function handleDragOver(e) {
        e.preventDefault();
    }


    var xpos = parseInt(item.x) * p1;
    var ypos = parseInt(item.y) * p1;

    var w = 1 //width || 2;

    /*
    {show ?
                <BkPopup handleMenuClick={handleMenuClick} anchorPoint={anchorPoint} bk={item}/>
            : null}onDrop={handleDrop} onDragOver={handleDragOver}
     */

    return (
        <div >
        <BkIcon item={item} handleArrowClick={handleArrowClick} />
        </div>
    )
}
/*
function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = (dispatch) => ({
    idClick: (lcid) => dispatch({type: 'LC_SELECT', selectedLc: lcid}),
});

export default connect(mapStateToProps, mapDispatchToProps)(Bk)
*/

export default Bk